<template>
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="200" rx="100" fill="#E8E8E8" />
    <g filter="url(#filter0_i_7118_40825)">
      <path
        d="M99.9998 99.9998C93.3762 99.9998 87.706 97.6414 82.9892 92.9246C78.2724 88.2078 75.914 82.5376 75.914 75.914C75.914 69.2904 78.2724 63.6201 82.9892 58.9033C87.706 54.1865 93.3762 51.8281 99.9998 51.8281C106.623 51.8281 112.294 54.1865 117.01 58.9033C121.727 63.6201 124.086 69.2904 124.086 75.914C124.086 82.5376 121.727 88.2078 117.01 92.9246C112.294 97.6414 106.623 99.9998 99.9998 99.9998ZM54.0177 148.171C52.8085 148.171 51.8281 147.191 51.8281 145.982V131.311C51.8281 127.899 52.7063 124.763 54.4625 121.903C56.2188 119.043 58.5521 116.86 61.4625 115.355C67.6846 112.243 74.0072 109.91 80.4301 108.355C86.8529 106.799 93.3762 106.021 99.9998 106.021C106.623 106.021 113.147 106.799 119.57 108.355C125.992 109.91 132.315 112.243 138.537 115.355C141.448 116.86 143.781 119.043 145.537 121.903C147.293 124.763 148.171 127.899 148.171 131.311V145.982C148.171 147.191 147.191 148.171 145.982 148.171H54.0177Z"
        fill="#AEAEAE"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_7118_40825"
        x="51.8281"
        y="51.8281"
        width="100.723"
        height="105.102"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4.37924" dy="8.75848" />
        <feGaussianBlur stdDeviation="10.9481" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_7118_40825" />
      </filter>
    </defs>
  </svg>
</template>
